/** Кольори тексту Markdown {колір|текст} (прототип MD_COLORS): червоний, помаранчевий, зелений, синій, фіолетовий, сірий. */
export const MD_COLOURS: Readonly<Record<string, string>> = {
  red: '#be123c', orange: '#c2410c', green: '#1f8a5b', blue: '#1f4ebc', purple: '#6b3fd1', grey: '#64748b',
};
